var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAirlineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,5H8A3,3,0,0,0,5,8V44a3,3,0,0,0,3,3H44a3,3,0,0,0,3-3V8A3,3,0,0,0,44,5Zm1,39a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8A1,1,0,0,1,8,7H44a1,1,0,0,1,1,1V28c-24.14.08-34.81,2.91-35.26,3A1,1,0,0,0,9,32v3a1,1,0,0,0,.46.84C9.92,36.14,21,43,45,43ZM35,34a1,1,0,0,1-1,1H20a1,1,0,0,1,0-2H34A1,1,0,0,1,35,34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.26,28.27a144.26,144.26,0,0,1,15.25-1.72L16.63,9.43A1,1,0,0,0,15.81,9H10a1,1,0,0,0-.78.38,1,1,0,0,0-.19.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAirlineLogo);
export default __webpack_public_path__ + "static/media/no_airline_logo.97800525f636550436b99f34ff8f499f.svg";
export { ForwardRef as ReactComponent };